<template>
<div class="">
    <div class="top-bar bg-primary py-2">
        <div class="container">
            <div class="row">
                <div class="col-12 col-md-7">
                    <ul class="list-inline mb-0 toplink text-center text-md-left">
                        <li class="list-inline-item">
                           <router-link to="/contact" class="text-white">Contact us</router-link>
                        </li>
                        <li class="list-inline-item">
                            <a href="https://fifmi.org.au:2096" target="_blank" class="text-white">Webmail</a>
                        </li>
                        <li class="list-inline-item">
                            <router-link to="/location" class="text-white">Locations Selector</router-link>
                        </li>
                        <li class="list-inline-item">
                            <router-link to="/online-giving" class="text-white">Give Online</router-link>
                        </li>
                    </ul>
                </div>
                <div class="col-12 col-md-5">
                    <ul class="list-inline mb-0 topsocial text-center text-md-right">
                        <li class="list-inline-item">
                            <router-link to="#" class="text-white"><i class="icofont icofont-facebook"></i></router-link>
                        </li>
                        <li class="list-inline-item">
                            <router-link to="#" class="text-white"><i class="icofont icofont-youtube"></i></router-link>
                        </li>
                        <li class="list-inline-item">
                           <router-link to="#" class="text-white"><i class="icofont icofont-vimeo"></i></router-link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="headermiddle">
        <div class="container">
            <div class="row align-items-center py-3">
                <div class="col-12 col-md-4">
                    <router-link to="/" class="site-logo"><img src="../assets/images/logo-dark.png" alt="" class="img-fluid"></router-link>
                    <button class="navbar-toggler d-md-none" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span class="navbar-toggler-icon"></span>
                        <span class="navbar-toggler-icon"></span>
                        <span class="navbar-toggler-icon"></span>
                    </button>
                </div>
                <div class="col-12 col-md-8 d-none d-md-block">
                    <div id="owlmarquee" class="owl-carousel owl-theme">
                        <div class="item" v-for="mediaaudio in mediaaudios" :key="mediaaudio.nid">
                            <div class="row justify-content-between align-items-center">
                                <router-link to="/audio-media" class="text-light volunter col-8">
                                    <div class="head-author">
                                        <div class="author-image float-left mr-3">
                                            <img :src="mediaaudio.field_basic_image" alt="" class="img-fluid" />
                                        </div>
                                        <div class="author-txt align-self-center">
                                            <span>
                                                <b class="text-danger author-title">{{ mediaaudio.title }}</b><b class="text-dark">{{ mediaaudio.field_audio_teacher }}</b> <span>{{ mediaaudio.revision_timestamp }}</span>
                                            </span>
                                        </div>
                                    </div>
                                </router-link>
                                <div class="ready-player-1 volunter-player col-4">
                                    <audio>
                                        <source :src="handleBase() + mediaaudio.field_audio_upload" type="audio/mpeg">
                                    </audio>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="menubar bg-primary">
        <div class="container px-0">
            <nav class="navbar navbar-expand-md p-0">
                <div class="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul class="navbar-nav">
                        <li class="nav-item active">
                            <router-link class="nav-link" to="/" data-toggle="dropdown"><i class="icofont icofont-home"></i></router-link>
                            <div class="dropdown-menu rounded-0 border-0 m-0">
                                <router-link class="dropdown-item" to="/coming-soon">New Zealand</router-link>
                                <router-link class="dropdown-item" to="/coming-soon">Tonga</router-link>
                                <router-link class="dropdown-item" to="/coming-soon">Fiji</router-link>
                                <router-link class="dropdown-item" to="/coming-soon">Solomon Islands</router-link>
                                <router-link class="dropdown-item" to="/coming-soon">Papua New Guinea</router-link>
                                <router-link class="dropdown-item" to="/coming-soon">Samoa</router-link>
                            </div>
                        </li>
                        <li class="nav-item dropdown">
                            <router-link class="nav-link" to="/About" data-toggle="dropdown">About Us</router-link>
                            <div class="dropdown-menu rounded-0 border-0 m-0">
                                <router-link class="dropdown-item" to="/our-founders">Our Founders</router-link>
                                <router-link class="dropdown-item" to="/our-history">Our History</router-link>
                               <router-link class="dropdown-item" to="/statement-of-faith">Statement Of Faith</router-link>
                                <router-link class="dropdown-item" to="/coming-soon">Our Beliefs</router-link>
                                <router-link class="dropdown-item" to="/coming-soon">Our Pastors</router-link>
                            </div>
                        </li>
                        <li class="nav-item dropdown">
                            <router-link class="nav-link" to="#" data-toggle="dropdown">Ministries</router-link>
                            <div class="dropdown-menu rounded-0 border-0 m-0">
                                <router-link class="dropdown-item" to="/children-ministry">Children Ministry</router-link>
                                <router-link class="dropdown-item" to="/youth">Xtreme Heirs (Youth)</router-link>
                                <router-link class="dropdown-item" to="/ladies-ministry">Go Quickly and Tell</router-link>
                                <router-link class="dropdown-item" to="/men-of-integrity">Men Of Integrity</router-link>
                                <router-link class="dropdown-item" to="/praise-and-worship">Praise and Worship</router-link>
                                <router-link class="dropdown-item" to="/missions">Missions</router-link>
                                <router-link class="dropdown-item" to="/coming-soon">Helps</router-link>
                            </div>
                        </li>
                        <li class="nav-item">
                            <router-link class="nav-link" to="/events">News & Updates</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link class="nav-link" to="/bible-school">Amfcc Bible School</router-link>
                        </li>

                        <li class="nav-item">
                           <router-link class="nav-link" to="/audio-media">Egea Media</router-link>
                        </li>

                        <li class="nav-item">
                            <router-link class="nav-link" to="/location">Locations</router-link>
                        </li>
                        <li class="nav-item">
                           <router-link class="nav-link" to="/events">Events</router-link>
                        </li>
                        <li class="nav-item">
                           <router-link class="nav-link" to="/contact">Contact Us</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link class="nav-link watch-live" to="/coming-soon">Watch Live</router-link>
                        </li>
                    </ul>
                </div>
            </nav>
        </div>
    </div>
</div>
</template>

<script>
import axios from 'axios';
import GreenAudioPlayer from '../assets/js/green-audio-player.js';
// import FlipCountdown from 'vue2-flip-countdown';

export default {
    name: 'Header',
    data(){
        return {
            mediaaudios: []
        }
    },
    components: {
        // FlipCountdown
    },
    mounted() {
        axios
        .get('https://api.fifmi.org.au/api/media-audio')
        .then(result => {
            for (var i = 0; i < result.data.length; i++) {
                if(result.data[i].field_domain_access.includes('fifmi')){
                    this.mediaaudios.push(result.data[i])
                }
            }
        });
    },
    updated() {
        this.$nextTick(function () {
            $('#owlmarquee').owlCarousel({
                loop:true,
                margin:0,
                items: 1,
                nav:false,
                dots: false,
                animateOut: 'fadeOut',
                autoplay:true,
                autoplayHoverPause:true
            });

            GreenAudioPlayer.init({
                selector: '.ready-player-1',
                stopOthersOnPlay: true
            });
        });
    },
    methods: {
        handleBase: function () {
            return "https://www.fifmi.org.au"
        }
    }
}
</script>
